module.exports = __webpack_public_path__ + "img/tz.3b3c590e.jpg";